import moment from 'moment'
import React, { FC, ReactElement, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import H3 from '../../components/h3'
import PlanHorizontal from '../../components/planHorizontal'
import PlanHorizontalLoading from '../../components/planHorizontal/loading'
import Skeleton from '../../components/skeleton'
import { Plan } from '../../externals/api/plans'
import { usePlans } from '../../hooks/plans'
import { toReais } from '../../utils/formatter'
import ModalCancelPlan from './modalCancelPlan'
import ModalSelectPlan from './modalSelectPlan'
import { PlansContainer } from './style'

const planLoading = (i = 1) => ({ _id: 'loading_' + i } as Plan)

const Plans: FC = (): ReactElement | null => {
  const { plans: _plans, get } = usePlans()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    get({ status: 'active' }).finally(() => setIsLoading(false))
  }, [get])

  const isSubscribedPlan = useMemo(() => {
    return _plans.find(p => p.isSubscribed)
  }, [_plans])

  const plans = isLoading ? [planLoading(1), planLoading(2), planLoading(3)] : _plans

  return (
    <PlansContainer>
      <H3 className='header'>
        Sua assinatura
        {!isSubscribedPlan?.cancellationEffectiveDate && (
          <Link className='cancel' to='?modal=cancel'>Cancelar plano</Link>
        )}
      </H3>
      {!isLoading && isSubscribedPlan
        ? (
          <>
            <H3>
              <span>Plano</span>
              <br />
              {isSubscribedPlan.name} - {toReais(isSubscribedPlan.pricing[0].price)}
            </H3>
            {isSubscribedPlan.cancellationEffectiveDate
              ? (
                <p className='plan_info'>
                  Seu plano está ativo até {moment(isSubscribedPlan.cancellationEffectiveDate).format('DD/MM/YYYY')}
                </p>
              )
              : (
                <p className='plan_info'>
                  A cobrança só acontecerá ao final do período gratuito de 15* dias
                  e você pode cancelar a qualquer momento.
                  <br />
                  *O período de acesso gratuito é válido somente uma vez, e não é
                  válido para quem acessou via convite.
                </p>
              )}
          </>
        )
        : (
          <>
            <H3>
              <span>Plano</span>
              <br />
              <Skeleton>
                {isLoading ? 'Carregando...' : '-'}
              </Skeleton>
            </H3>
            <Skeleton>
              <p className='plan_info'>
                Carregando dados do plano...
              </p>
            </Skeleton>
          </>
        )}
      <h3 className='subtitle'>Alterar plano</h3>
      <div className='plans_listing'>
        {plans.map(plan => {
          if (isLoading) return <PlanHorizontalLoading key={`plan-${plan._id}`} />

          return (
            <PlanHorizontal
              key={`plan-${plan._id}`}
              name={plan.name}
              items={plan.items}
              price={plan.pricing[0].price}
              isActive={plan.isSubscribed}
              to={plan.isSubscribed ? undefined : `?modal=plan&planId=${plan._id}`}
            />
          )
        })}
      </div>
      <ModalCancelPlan />
      <ModalSelectPlan />
    </PlansContainer>
  )
}

export default Plans
